// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b_oN","placeholdersHeader":"styles_placeholdersHeader__HkGS5","editorStyle":"styles_editorStyle__1kon8","placeholdersBox":"styles_placeholdersBox__kcHjP"};